import { ReactComponent } from "./left-angle-bracket-line.svg";

interface Props {
  fill?: string;
  width?: string;
  height?: string;
}

const LeftAngleBracketLineIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default LeftAngleBracketLineIcon;
